<template>
  <div>
    <Button icon="pi pi-eye" text @click="openDetailGoodsDialog()"></Button>

    <Dialog position="top" :draggable="false" v-model:visible="DetailGoodsModal" modal
      header="Thông tin Mua lại/Đổi hàng" :style="{ width: '800px' }">
      <div class="flex flex-column gap-3">
        <div class="grid">
          <div class="col-6 flex flex-column gap-2">
            <label>Mã hàng hóa</label>
            <InputText v-model="props.data.itemName"></InputText>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label>Serial</label>
            <InputText v-model="props.data.serialBatchNumber"></InputText>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 flex flex-column gap-3">
            <label>Lý do nhập</label>
            <div class="flex gap-4">
              <div class="flex gap-2">
                <RadioButton v-model="payload.reason" value="Y"></RadioButton>
                <label>Mua lại</label>
              </div>
              <div class="flex gap-2">
                <RadioButton v-model="payload.reason" value="N"></RadioButton>
                <label>Trả hàng</label>
              </div>
            </div>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label>Mô tả</label>
            <Textarea></Textarea>
          </div>
        </div>
        <div class="grid">
          <div class="col flex flex-column gap-2">
            <label>Nguyên liệu vàng</label>
            <Dropdown :options="GoldContentOpt" optionLabel="name" placeholder="--Chọn nguyên liệu vàng--"></Dropdown>
          </div>
          <div class="col flex flex-column gap-2">
            <label>Giá vàng</label>
            <InputText disabled v-model="props.data.goldAmount"></InputText>
          </div>
        </div>
      </div>
      <strong>Thông tin sản phẩm</strong>
      <div class="grid mt-3">
        <div class="col-6">
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>Giá bán ra sau CK (VND)</span>
            </div>
            <div class="col-5">
              <InputNumber :placeholder="Intl.NumberFormat().format(props.data.price * props.data.quantity)
                " disabled class="w-full"></InputNumber>
            </div>
          </div>
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>% Mua lại/Đổi hàng</span>
            </div>
            <div class="col-5">
              <InputNumber class="w-full" disabled v-model="payload.percent" suffix="%"></InputNumber>
              <div class="hidden">{{ percent }}</div>
            </div>
          </div>
          <div class="grid align-items-center mb-2">
            <div class="col-12">
              <div class="flex items-center">
                <Checkbox v-model="payload.policy" :trueValue="15" :falseValue="0" binary />
                <label for="ingredient1" class="ml-2">
                  Mua lại theo chính sách (15%)
                </label>
              </div>
            </div>
            <div class="col-12">
              <div class="flex items-center">
                <Checkbox v-model="payload.scratch" :trueValue="5" :falseValue="0" binary />
                <label for="ingredient1" class="ml-2"> Xước (5%) </label>
              </div>
            </div>
            <div class="col-12">
              <div class="flex items-center">
                <Checkbox v-model="payload.lost_stones" :trueValue="10" :falseValue="0" binary />
                <label for="ingredient1" class="ml-2"> Mất đá (10%) </label>
              </div>
            </div>
            <div class="col-12">
              <div class="flex items-center">
                <Checkbox v-model="payload.mop" :trueValue="15" :falseValue="0" binary />
                <label for="ingredient1" class="ml-2"> Móp,méo (15%) </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>Trọng lượng cũ (gr)</span>
            </div>
            <div class="col-5">
              <InputNumber v-model="props.data.totalWeight" class="w-full"></InputNumber>
            </div>
          </div>
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>Trọng lượng cân lại (gr)</span>
            </div>
            <div class="col-5">
              <InputNumber class="w-full"></InputNumber>
            </div>
          </div>
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>Chênh lệch (gr)</span>
            </div>
            <div class="col-5">
              <InputNumber class="w-full"></InputNumber>
            </div>
          </div>
          <div class="grid align-items-center mb-2">
            <div class="col-7">
              <span>Tiền hao hụt (VND)</span>
            </div>
            <div class="col-5">
              <InputNumber class="w-full" disabled :value="MoneyLost"
                :placeholder="Intl.NumberFormat().format(MoneyLost)"></InputNumber>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="flex gap-2">
          <Button outlined label="Hủy" @click="DetailGoodsModal = false"></Button>
          <Button label="Xác nhận" @click="SaveProti"></Button>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import { ref, computed, onBeforeMount } from "vue";
import API from "../../../api/api-main";

const payload = ref({
  reason: "Y",
  policy: 0,
  scratch: 0,
  lost_stones: 0,
  mop: 0,
  percent: 0,
});

const percent = computed(() => {
  let total =
    payload.value.policy +
    payload.value.scratch +
    payload.value.lost_stones +
    payload.value.mop;
  payload.value.percent = total;
  return total;
});
const GoldContentOpt = ref([])
const DetailGoodsModal = ref(false);
const props = defineProps({
  data: Object,
});
const openDetailGoodsDialog = () => {
  fetchGoldContent()
  DetailGoodsModal.value = true;
};

const MoneyLost = computed(() => {
  props.data.moneylost = (props.data.price * props.data.quantity * percent.value) / 100;
  return (props.data.price * props.data.quantity * percent.value) / 100;
});

const SaveProti = () => {
  DetailGoodsModal.value = false;
  props.data.lineTotal = props.data.price * props.data.quantity - MoneyLost.value;
};
const fetchGoldContent = async () => {
  try {
    const res = await API.get(`GoldContent/getall`)
    GoldContentOpt.value = res.data
  } catch (error) {

  }
}
</script>
<style scoped>
:deep(.p-inputnumber-input) {
  width: 100%;
}
</style>
